/** Einheitliche deutsche Darstellung von Datum, Geld und Vorgängen. */

const dateFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const moneyFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value.length === 10 ? `${value}T00:00:00` : value);
  return Number.isNaN(date.getTime()) ? '—' : dateFormat.format(date);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : dateTimeFormat.format(date);
}

export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const numeric = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(numeric) ? '—' : moneyFormat.format(numeric);
}

/** „vor 3 Tagen" — für Historien angenehmer als ein volles Datum. */
export function formatRelative(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  const diffMs = Date.now() - date.getTime();
  const minutes = Math.round(diffMs / 60_000);
  if (Math.abs(minutes) < 1) return 'gerade eben';
  if (Math.abs(minutes) < 60) return `vor ${minutes} Min.`;

  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return `vor ${hours} Std.`;

  const days = Math.round(hours / 24);
  if (Math.abs(days) < 31) return `vor ${days} ${days === 1 ? 'Tag' : 'Tagen'}`;

  return formatDate(value);
}

export const MOVEMENT_LABELS: Record<string, string> = {
  create: 'Angelegt',
  checkout: 'Ausgegeben',
  checkin: 'Zurückgenommen',
  transfer: 'Übergeben',
  status: 'Status geändert',
  update: 'Bearbeitet',
};

export const SOURCE_LABELS: Record<string, string> = {
  ui: 'Oberfläche',
  api: 'API',
  mcp: 'Claude Code',
  import: 'Import',
  system: 'System',
};
